module.exports = __webpack_public_path__ + "img/file-upload-form.285a30c7.png";